import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import api from './services/api';
import routing from './services/routing';

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        [routing.name]: routing.reducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
